// react
import { useEffect, useRef } from "react";
// components
import OverLay from "../OverLay/OverLay";
// classnames
import ClassNames from "classnames";

const Modal = (props) => {
  // props
  const { close, classNames } = props;
  // refs
  const modalRef = useRef();

  useEffect(() => {
    if (modalRef.current) {
      modalRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [modalRef]);
  return (
    <>
      <OverLay clicked={close} />
      <div
        className={ClassNames(
          "modal rounded-lg border border-light-gray bg-white w-10/12 sm:w-1/2 z-50 p-6",
          classNames
        )}
        ref={modalRef}
      >
        {props.children}
      </div>
    </>
  );
};
export default Modal;
